import { t } from 'utils/i18n';
import {
  CREATE_ACT_REVISION,
  CREATE_CLAIM,
  CREATE_PAYMENT_SCHEDULE,
} from 'constants/actions';

export const tabs = [
  { label: t('history'), value: 'history' },
  { label: t('paymentSchedule'), value: 'invoices' },
  { label: t('payments'), value: 'payments' },
  { label: t('documents'), value: 'docs' },
  { label: t('pledges'), value: 'pledges' },
  { label: t('tasks'), value: 'tasks' },
  { label: t('chat'), value: 'chat' },
];

export const actions = [
  { id: CREATE_ACT_REVISION, title: t(CREATE_ACT_REVISION), show: 'never' },
  { id: CREATE_CLAIM, title: t(CREATE_CLAIM), show: 'never' },
  {
    id: CREATE_PAYMENT_SCHEDULE,
    title: t(CREATE_PAYMENT_SCHEDULE),
    show: 'never',
  },
];
